import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DurationLabelContainer,
  DurationLabelText,
  VideoCameraIcon,
} from './styles';

interface DurationLabelProps {
  duration?: number | null;
  className?: string;
}

export default ({ duration, className }: DurationLabelProps) => {
  const { t } = useTranslation('book', { keyPrefix: 'practitioner.book' });
  const formattedDuration = t('duration', {
    duration: duration ?? 0,
  });

  return (
    <DurationLabelContainer className={className}>
      <VideoCameraIcon />
      <DurationLabelText>{formattedDuration}</DurationLabelText>
    </DurationLabelContainer>
  );
};
